export default __webpack_public_path__ + "static/media/Brooster-Rooster-2.7d498c1e.png";